import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from "../../../../store/actionCreators/dialog";
import { getGlobalAccountBalance } from "../../../../store/selectors";

const LevelRow = ({ club, isActive }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const globalBalance = useSelector(getGlobalAccountBalance);

  const buyLevel = () => {
    if (isActive) {
      if (club.cost > globalBalance.diamonds) {
        dispatch(openDialog('notEnoughFunds'))
      } else {
        dispatch(openDialog('buyLevel', club));
      }
    }
  };

  return (
    <div className={`clubRow ${!isActive && 'inactive'}`} onClick={buyLevel}>
      <div className={`startColumn`}>
        <div className={`star${club.level}`}></div>
      </div>
      <div className={`middleColumn`}>
        <div className="topRow">
          <span className="clubName">
            {t(`clubLevelName.${club.level}`)}
          </span>
          <span className="cost">{`${club.cost}`}</span>
        </div>
        <div className="middleRow">
          {club.extra ? <span className="extra">{club.extra}</span> : ''}
          <span className="expiration">{t('vipValidDate')}</span>
        </div>
        <div className="bottomRow">
          <span className="member">{`${t('member')}: ${club.memberLimit}`}</span>
          <span className="manager">{`${t('manager')}: ${club.managerLimit}`}</span>
        </div>
      </div>
    </div>
  );
};

export default LevelRow;
